<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9XhNSJ/tc-custom/9780253013019.jpg?1728259236022" alt="This image is the cover for the book Global Rome, New Anthropologies of Europe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Global Rome, New Anthropologies of Europe
      </h1>
      <p class="bookDescription body article font2">
        <b>Delving into topics from immigration to sustainability, this is “an original, rich, and important contribution to the study of Rome” (<i>H-Italy</i>).</b><br/><br/>Is twenty-first-century Rome a global city? Is it part of Europe’s core or periphery? This volume examines the “real city” beyond Rome’s historical center, exploring the diversity and challenges of life in neighborhoods affected by immigration, neoliberalism, formal urban planning, and grassroots social movements.<br/><br/>The contributors engage with themes of contemporary urban studies—the global city, the self-made city, alternative modernities, capital cities and nations, urban change from below, and sustainability. <i>Global Rome</i> serves as a provocative introduction to the Eternal City and makes an original contribution to interdisciplinary scholarship.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Clough Isabella Marinaro, Bjørn Thomassen
      </h2>
      
      <p class="authorDescription body article"><P>Isabella Clough Marinaro is Assistant Professor of Italian Studies at John Cabot University, Rome.</P><P>Bjørn Thomassen is Associate Professor in the Department of Society and Globalisation, Roskilde University, Denmark.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?534c641f